<template>
  <div class="solution">
    <!-- 顶部 banner -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">农资供应链数字化解决方案</h1>
        <p class="banner-desc aw-anim">破解农资流通协同难题，数字化串联产销配全流程，降本增效，打造可溯源的农资供应链生态</p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 方案简介 -->
    <section class="intro-section">
      <h2 class="section-title aw-anim">方案简介</h2>
      <div class="intro-body">
        <div class="intro-img">
          <img :src="introImg" alt="方案配图" />
        </div>
        <div class="intro-text aw-anim">
          <p>{{ introText }}</p>
        </div>
      </div>
    </section>

    <!-- 行业痛点 -->
    <section class="pain-section">
      <h2 class="section-title aw-anim">行业痛点</h2>
      <div class="pain-grid">
        <div class="pain-card aw-anim" v-for="(item, index) in painPoints" :key="index">
          <img class="pain-icon" :src="item.icon" :alt="item.title" />
          <h3 class="pain-title">{{ item.title }}</h3>
          <p class="pain-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 核心能力 -->
    <section class="cap-section">
      <h2 class="section-title aw-anim">核心能力</h2>
      <div class="cap-grid">
        <div class="cap-card aw-anim" :class="{ featured: item.featured }" v-for="(item, index) in capabilities"
          :key="index">
          <img class="cap-icon" :src="item.icon" :alt="item.title" />
          <h3 class="cap-title">{{ item.title }}</h3>
          <p class="cap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 客户价值 -->
    <section class="value-section">
      <h2 class="section-title aw-anim">客户价值</h2>
      <div class="value-body">
        <div class="value-text aw-anim">
          <p>{{ valueText }}</p>
        </div>
        <div class="value-img">
          <img :src="valueImg" alt="客户价值全景" />
        </div>
      </div>
    </section>
    <!-- 在线留言 -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "SolutionPage3",
  components: { ContactMessageForm },
  data() {
    return {
      introImg: require("@/assets/solution/agriSupply/solution_overview.png"),
      valueImg: require("@/assets/solution/agriSupply/customer_value.png"),
      introText: "构建全链路农资流通数字化体系，覆盖农资生产、采购、批发、门店零售、终端配送全流程，整合供应链管理、智慧门店、会员营销、库存管控、交易结算核心能力。通过平台统一交易服务层，实现上下游资源协同，搭配移动端工具，打造规范化、高效化、可溯源的农资供应链生态",
      valueText: "打通农资上下游流通壁垒，实现供应链高效协同，降低流通与仓储成本；赋能传统农资门店数字化转型，拓展线上经营渠道，提升门店营收与客户粘性；实现农资全流程溯源，规范经营体系，规避经营风险",
      painPoints: [
        {
          icon: require("@/assets/solution/agriSupply/sol_isol_pain1.png"),
          title: "供应链协同低效",
          desc: "农资供应链链路长，上下游信息不对称，采购、调拨、配送协同效率低下",
        },
        {
          icon: require("@/assets/solution/agriSupply/sol_isol_pain2.png"),
          title: "门店经营粗放",
          desc: "线下农资门店经营粗放，库存混乱、会员流失、营销方式单一",
        },
        {
          icon: require("@/assets/solution/agriSupply/sol_isol_pain3.png"),
          title: "质量溯源缺失",
          desc: "农资商品无全程溯源，质量管控难，售后纠纷难以追溯",
        },
        {
          icon: require("@/assets/solution/agriSupply/sol_isol_pain4.png"),
          title: "数据决策滞后",
          desc: "交易、对账、结算人工操作量大，数据统计滞后，经营决策无依据",
        }
      ],
      capabilities: [
        {
          icon: require("@/assets/solution/agriSupply/sol_cap1.png"),
          title: "全链条供应链管控",
          desc: "商品中心统一管理、供应商准入审核、采购询价、调拨配送、批次溯源",
          featured: false,
        },
        {
          icon: require("@/assets/solution/agriSupply/sol_cap2.png"),
          title: "智慧门店三端协同",
          desc: "旺店移动端（门店管理）、POS收银端（快速结算）、村村团用户端（线上下单）",
          featured: false,
        },
        {
          icon: require("@/assets/solution/agriSupply/sol_cap5.png"),
          title: "智能经营赋能",
          desc: "库存实时监控、会员体系管理、精准营销、门店经营数据分析",
          featured: true,
        },

        {
          icon: require("@/assets/solution/agriSupply/sol_cap4.png"),
          title: "标准化交易能力",
          desc: "统一订单管理、线上结算、售后管控、交易数据自动统计",
          featured: false,
        },
        {
          icon: require("@/assets/solution/agriSupply/sol_cap3.png"),
          title: "AI门店助手",
          desc: "智能导购、农资适配推荐、常见问题智能答疑",
          featured: false,
        },
      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.solution {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("~@/assets/solution/agriSupply/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  margin-bottom: 40px;
  text-align: center;
  line-height: 32px;
}

/* ============ 方案简介 ============ */
.intro-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.intro-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.intro-img {
  //   flex: 0 0 518px;

  img {
    width: 518px;
    height: 345px;
    display: block;
  }
}

.intro-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

/* ============ 行业痛点 ============ */
.pain-section {
  padding: 80px 0;
  background: #ffffff;
}

.pain-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.pain-card {
  background: #f5f8fe;
  border-radius: 12px;
  //   padding: 44px 28px;/
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  padding: 32px 24px 12px 32px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }
}

.pain-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.pain-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
  line-height: 20px;
}

.pain-desc {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  margin: 0;
  text-align: justify;
  text-align-last: center;
}

/* ============ 核心能力 ============ */
.cap-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.cap-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cap-card {
  grid-column: span 2;
  background: #ffffff;
  //   border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 32px 24px 0 32px;
  display: flex;
  flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  height: 250px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }

  /* 前两张各占半行 */
  &:nth-child(1),
  &:nth-child(2) {
    grid-column: span 3;
  }

  /* 第一张：蓝色渐变底 */
  &.featured {
    border: none;
    background: url("~@/assets/solution/bg2.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.cap-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.cap-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin: 0 0 16px;
}

.cap-desc {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

/* ============ 客户价值 ============ */
.value-section {
  padding: 80px 0;
  background: #ffffff;
}

.value-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.value-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

.value-img {
  img {
    width: 518px;
    height: 302px;
    display: block;
  }
}
</style>